import { render, staticRenderFns } from "./ApproachPf.vue?vue&type=template&id=38e245d4&"
import script from "./ApproachPf.vue?vue&type=script&lang=js&"
export * from "./ApproachPf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports